<template>
  <div>
    <TFHero />
    <TFProblem />
    <TFSolution />
    <TFPricing />
    <TFCases />
    <TFFAQ />
    <TFContact />
  </div>
</template>

<script>
import AOS from 'aos';
import TFHero from '../components/tradeflow/TFHero.vue';
import TFProblem from '../components/tradeflow/TFProblem.vue';
import TFSolution from '../components/tradeflow/TFSolution.vue';
import TFPricing from '../components/tradeflow/TFPricing.vue';
import TFCases from '../components/tradeflow/TFCases.vue';
import TFFAQ from '../components/tradeflow/TFFAQ.vue';
import TFContact from '../components/tradeflow/TFContact.vue';

export default {
  name: 'TradeFlowPage',
  components: {
    TFHero, TFProblem, TFSolution, TFPricing, TFCases, TFFAQ, TFContact,
  },
  mounted() {
    AOS.refresh();
  },
};
</script>
